// extracted by mini-css-extract-plugin
module.exports = {"masthead":"Masthead_masthead__3GQgr"};